import { render, staticRenderFns } from "./InsuranceRefundInvoice.vue?vue&type=template&id=12e48614&scoped=true&"
import script from "./InsuranceRefundInvoice.vue?vue&type=script&lang=js&"
export * from "./InsuranceRefundInvoice.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceRefundInvoice.vue?vue&type=style&index=0&id=12e48614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e48614",
  null
  
)

export default component.exports